import {FormFieldTypes} from "./enums";
import {
  fontFamilySelectOptions, fontSizeSelectOptions,
  localeSelectOptions,
  textAlignSelectOptions,
  textDirectionSelectOptions,
  timezoneSelectOptions
} from "./selectOptions";

export const CreateTemplateFormValidation = {
  templateName: {required: "Template name is required.", maxLength: {value: 50, message: "You may provide at most 50 characters for Template Name."}},
  id: {required: "Please select the document format."},
  document: {required: "A PDF file is required."}
};

export const SettingsFormModel = {
  fields:  [
    { id: "name", label: "Template Name", type: FormFieldTypes.SHORT_STRING },
    { id: "fileNameFormat", label: "File Name Format", variables: "", type: FormFieldTypes.EXPRESSION },
    { id: "formatId", label: "Document Format", type: FormFieldTypes.DOCUMENT_FORMAT_SELECT },
    { id: "locale", label: "Locale", type: FormFieldTypes.SELECT, options: localeSelectOptions },
    { id: "timezone", label: "Timezone", type: FormFieldTypes.SELECT, options: timezoneSelectOptions },
    { id: "description", label: "Description", type: FormFieldTypes.LONG_STRING },
  ],
  validation: {
    name: {required: "Template name is required.", maxLength: {value: 50, message: "Maximum is 50 characters."}},
    fileNameFormat: {maxLength: {value: 500, message: "Maximum is 500 characters."}},
    id: {required: "Please select the document format."},
    locale: {required: "Please select the document locale."},
    timezone: {},
    description: {maxLength: {value: 250, message: "Maximum is 250 characters."}}
  }
};

export const FillableSettingsFormModel = {
  fields:  [
    { id: "name", label: "Template Name", type: FormFieldTypes.SHORT_STRING },
    { id: "fileNameFormat", label: "File Name Format", variables: "", type: FormFieldTypes.EXPRESSION },
    { id: "locale", label: "Locale", type: FormFieldTypes.SELECT, options: localeSelectOptions },
    { id: "timezone", label: "Timezone", type: FormFieldTypes.SELECT, options: timezoneSelectOptions },
    { id: "description", label: "Description", type: FormFieldTypes.LONG_STRING },
    { id: "flatten", label: "Finalize (flatten) PDF Form document", type: FormFieldTypes.CHECKBOX },
    { id: "direction", label: "Default Text Direction", type: FormFieldTypes.SELECT, options: textDirectionSelectOptions }
  ],
  validation: {
    name: {required: "Template name is required.", maxLength: {value: 50, message: "Maximum is 50 characters."}},
    fileNameFormat: {maxLength: {value: 500, message: "Maximum is 500 characters."}},
    id: {required: "Please select the document format."},
    locale: {required: "Please select the document locale."},
    timezone: {},
    description: {maxLength: {value: 250, message: "Maximum is 250 characters."}},
    flatten: {},
    direction: {}
  }
}

export const AttachedFileSettingsFormModel = {
  fields:  [
    { id: "file", label: "Replace PDF Form file", type: FormFieldTypes.FILE },
    { id: "submitReplace", label: "Replace PDF Form file", type: FormFieldTypes.SUBMIT },
  ],
  validation: {
  }
}

export const SecurityFormModel = {
  fields:  [
    { id: "canPrint", label: "Print", type: FormFieldTypes.CHECKBOX },
    { id: "canPrintDegraded", label: "Print Degraded quality only", type: FormFieldTypes.CHECKBOX, level: 1 },
    { id: "canModify", label: "Modify", type: FormFieldTypes.CHECKBOX },
    { id: "canAssembleDocument", label: "Assemble Document", type: FormFieldTypes.CHECKBOX, level: 1 },
    { id: "canModifyAnnotations", label: "Modify Annotations, Add Comments", type: FormFieldTypes.CHECKBOX, level: 1 },
    { id: "canFillInForm", label: "Fill in Form, Sign", type: FormFieldTypes.CHECKBOX, level: 2 },
    { id: "canExtractContent", label: "Extract Content", type: FormFieldTypes.CHECKBOX },
    { id: "canExtractForAccessibility", label: "Extract for Accessibility", type: FormFieldTypes.CHECKBOX, level: 1 },
    { id: "userPwd", label: "Document open password", variables: "", type: FormFieldTypes.EXPRESSION },
    { id: "ownerPwd", label: "Owner password", variables: "", type: FormFieldTypes.EXPRESSION },
  ],
  validation: {}
};

export const PdfEditorModalFormModel = {
  fields: [
    { id: "expression", label: "Data (expression)", type: FormFieldTypes.EXPRESSION },
    { id: "font", label: "Font Family", type: FormFieldTypes.SELECT, options: fontFamilySelectOptions, required: true },
    { id: "size", label: "Font Size", type: FormFieldTypes.SELECT, options: fontSizeSelectOptions, required: true },
    { id: "color", label: "Text Color", type: FormFieldTypes.COLOR },
    { id: "align", label: "Text align", type: FormFieldTypes.SELECT, options: textAlignSelectOptions },
    { id: "multiline", label: "Multiline", type: FormFieldTypes.CHECKBOX }
  ],
  validation: {}
};
